import { mapCollection } from '../../utils/collection.utils';
import { MasterTask } from '../master-task';
import { MasterTaskToolBuilder } from './master-task-tool.builder';
import { AdapterBuilder } from './adapter.builder';

export class MasterTaskBuilder {
  static fromJson(json) {
    return (json)
      ? new MasterTask(
        json.hash,
        json.name,
        json.identifier,
        MasterTaskToolBuilder.fromList(json.masterTaskTools),
        AdapterBuilder.fromJson(json.adapter).hash,
        AdapterBuilder.fromJson(json.adapter).name
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(MasterTaskBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/master-task.builder.ts